import { GiactContainer } from '../../GIACT/GiactContainer';
import React from 'react';
import { useField } from 'formik';
import { useGetBankWireRoutingNumberQuery } from '../../../../../../../API/order/escrow/WireDisbursementAPI';
import { IWireDisbursementFormData } from '../../../../../../../types/order/escrow/wires/IWireDisbursementFormData';

export const GiactField: React.FC<{ isReadOnly: boolean; isDirty: boolean }> = ({ isDirty, isReadOnly }) => {
  const [{ value: data }] = useField<IWireDisbursementFormData>('value');

  const { data: bankName } = useGetBankWireRoutingNumberQuery(data.routingNumber ?? '', {
    skip: data.routingNumber?.length !== 9,
  });

  if (isDirty || isReadOnly) {
    return null;
  }

  return (
    <GiactContainer
      routingNumber={data.routingNumber ?? ''}
      accountNumber={data.accountNumber}
      beneficiaryName={data.beneficiary}
      routingBankName={bankName?.name}
      disbursementType={data.type}
      disbursementId={data.id}
      isReadOnly={isReadOnly}
      giact={data.giact}
    />
  );
};
